import React, {Component} from 'react';
import {Card, Breadcrumb} from 'semantic-ui-react';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import localDB from "../../data/localDB";
import CardDash from "../../components/extras/CardDash";

class InventoriesDash extends Component {
    constructor() {
        super();
        this.state = {
            cards: []
        };
    }

    componentDidMount() {
        this.itemsMenu();
    }

    async itemsMenu() {
        let menu = await localDB.get('menu');
        let cards = menu.filter(menu => menu.type === 'inventories').map(item => {
            return (
                <CardDash {...item} key={item.url}/>
            )
        });
        this.setState({cards});
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Invetarios - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section active>Invetarios</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Card.Group stackable centered>
                    {this.state.cards}
                </Card.Group>
            </div>
        );
    }
}

export default InventoriesDash;



// WEBPACK FOOTER //
// ./src/containers/inventories/InventoriesDash.js